/**
 * @ngdoc controllers
 * @memberof mercury.modules.time.compliance.payrules
 * @name TimeCompliancePayRulesRemovePackageDialogCtrl
 * @description A confirmation dialog for removing a pay rule package.
 */
angular.module('mercury.modules.time.compliance.payrules')
.controller('TimeCompliancePayRulesRemovePackageDialogCtrl', ["dialog", "$scope", function(dialog, $scope) {
  $scope.confirm = function() {
    dialog.close({
      confirmed: true
    });
  };

  $scope.close = function() {
    // Just close the dialog and return nothing
    dialog.close();
  };
}]);
